<template>
  <div ref="container">
    <h3>動画プレビュー</h3>
    <YouTube
      ref="yt"
      class="yt"
      :width="videoWidth"
      :height="(videoWidth * 9) / 16"
      :src="src"
    />
    <div class="ct">{{ timestamp }}</div>
    <div>
      <button @click="player.playVideo">Play</button>
      <button @click="player.pauseVideo">Pause</button>
    </div>
    <div>
      <button @click="dif(-180)">←3min</button>
      <button @click="dif(-60)">←1min</button>
      <button @click="dif(60)">1min→</button>
      <button @click="dif(180)">3min→</button>
    </div>
    <div>
      <button @click="dif(-30)">←30sec</button>
      <button @click="dif(-10)">←10sec</button>
      <button @click="dif(10)">10sec→</button>
      <button @click="dif(30)">30sec→</button>
    </div>
    <div v-if="dup.length > 0" class="dup">
      <h4>以下の歌が登録されています</h4>
      <template v-for="item in dup" :key="item"
        ><div>{{ item.screenTitle }}</div></template
      >
    </div>
    <div v-else class="dup">
      <h4>この動画から登録されている歌はありません</h4>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import YouTube from "vue3-youtube";
import { useStore } from "vuex";
import firebase from "../firebase/firebase";

export default defineComponent({
  name: "VideoPreview",
  components: { YouTube },
  props: {
    src: {
      type: String,
      default: "https://youtu.be/4N_HwrzWCac",
    },
  },
  data() {
    // eslint-disable-next-line
    let player = null;

    return {
      videoWidth: 10,
      player: player,
    };
  },
  setup() {
    const store = useStore();
    const currentTime = ref(0);
    return { store, currentTime, dup: ref([]) };
  },
  mounted() {
    this.videoWidth = this.$refs.container.clientWidth;
    this.player = this.$refs.yt;
    setInterval(this.getCurrentTime, 100);
  },
  methods: {
    play(){
      this.player.playVideo();
    },
    play2sec() {
      this.player.playVideo();
      setTimeout(this.stop, 1500);
    },
    stop() {
      this.player.pauseVideo();
    },
    getCurrentTime:async function() {
      this.currentTime = await this.player.getCurrentTime();
      this.store.commit("setCurrentTime", this.currentTime);
      return this.currentTime;
    },
    jumpAt: async function (dist) {
      await this.player.seekTo(dist);
    },
    dif: async function (d) {
      this.jumpAt(this.currentTime + d);
    },
    num2stamp(time) {
      const h = Math.floor(time / 3600);
      const m = Math.floor((time % 3600) / 60);
      const s = Math.floor(time % 60);
      const hs = ("00" + h).slice(-2);
      const ms = ("00" + m).slice(-2);
      const ss = ("00" + s).slice(-2);
      return hs + ":" + ms + ":" + ss;
    },
    search() {
      firebase
        .firestore()
        .collection("songs")
        .where("videoId", "==", this.src)
        .get()
        .then((snap) => {
          this.dup.splice(0);
          snap.forEach((doc) => {
            this.dup.push(doc.data());
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    timestamp() {
      return this.num2stamp(this.currentTime);
    },
  },
  watch: {
    src() {
      this.search();
    },
  },
});
</script>

<style scoped>
.yt {
  margin: auto;
}
.ct {
  margin: 5px;
}
.dup {
  margin: 5px;
}
button {
  width: 20%;
  max-width: 100px;
  height: 30px;
  margin: 2px;
  outline: none;
  border: 2px solid #666;
}
</style>
